<template>
    <v-data-table
        :headers="headers"
        :items="reservees"
        :hide-default-footer="true"
        :items-per-page="100"
        sort-by="calories"
        class="elevation-1 bordered renters-list-table"
    >
        <!-- Table toolbar -->
        <template v-slot:top>
            <v-toolbar flat class="grey lighten-4 p-2">
                <v-toolbar-title><h4 class="m-0">{{ title }}</h4></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                        <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>
        </template>

        <!-- Column # -->
        <template v-slot:item.index="{ item }">
            <template v-if="item._id">
                {{ indexOfItem(item) }}
            </template>
        </template>
        <!-- Column Renter -->
        <template v-slot:item.renter="{ item }">

            <div class="d-flex flex-column" v-if="item._id">
                <template v-if="item.full_name">
                    <div>
                    <span><strong>{{ item.full_name }}</strong>, {{ item.gender }}, {{
                            ageFromBday(item.dob)
                        }} y.o. </span>
                    </div>
                    <div>
                        <span>{{ formatDate(item.dob) }}</span>
                    </div>
                </template>
                <template v-else>
                    <span class="text-warning">Not set</span>
                </template>
            </div>
        </template>
        <!-- Column Parameters -->
        <template v-slot:item.parameters="{ item }">
            <div class="d-flex flex-column" v-if="item._id">
                <div>
                    <strong>Height:</strong> <span>{{ heightCm(item.height) }}</span>
                </div>
                <div>
                    <template v-if="is_international_canadian">
                        <strong>Weight <template v-if="weight_unit_is_kg || $store.state.model.reservation.is_international_customer">Kg's</template><template v-if="weight_unit_is_kg==0 && !$store.state.model.reservation.is_international_customer">Lbs</template>:</strong> <span>{{ item.weight }}</span>
                    </template>
                    <template v-else>
                        <strong>Weigh <template v-if="weight_with_kg || $store.state.model.reservation.is_international_customer">Kg's</template>:</strong> <span>{{ item.weight }}</span>
                    </template>
                </div>
                <div>
                    <strong>Shoe size:</strong> <span>{{ shoeSize(item.shoe_size) }}</span>
                </div>
            </div>
        </template>
        <!-- Column Skier type -->
        <template v-slot:item.skier_type="{ item }">
            <div class="d-flex justify-content-center align-items-center h-100 w-100" v-if="item._id && item.skier_type">
                <span>{{ skierTypeById(item.skier_type).title }}</span>
            </div>
        </template>
        <!-- Column Package -->
        <template v-slot:item.package_id="{ item }">
            <div class="d-flex flex-column justify-content-center align-items-center h-100 w-100"
                 v-if="item._id && item.package_id">
                <span>{{ packageText(item) }}</span>
                <template v-if="item.addons && item.addons.length">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span class="text-light-blue"
                               v-bind="attrs"
                               v-on="on"
                            >
                                + {{ item.addons.length }} addons
                            </span>
                        </template>
                        <span>{{ addonsText(item) }}</span>
                    </v-tooltip>
                </template>
            </div>
        </template>
        <!-- Column Actions -->
        <template v-slot:item.actions="{ item }">
            <div class="d-flex justify-content-center align-items-center  h-100 w-100" v-if="item._id">
                <v-icon
                    class="mr-2"
                    color="accent"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    color="error"
                    @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </div>
        </template>

        <!-- Header Skier type -->
        <template v-slot:header.skier_type>
            <span>Skier Type</span>
            <v-btn
                icon
                @click="ui__openModalByName({name:'dialog_skier_types'})"
            >
                <v-icon>mdi-information-outline</v-icon>
            </v-btn>
        </template>
        <!-- Header Package -->
        <template v-slot:header.package_id>
            <span>Package</span>

            <v-btn
                icon
                @click="ui__openModalByName({name:'dialog_rental_rates'})"
            >
                <v-icon>mdi-information-outline</v-icon>
            </v-btn>
        </template>
    </v-data-table>
</template>

<script>
import ReserveeModel  from "../../models/ReserveeModel";
import UiManagerMixin from "../../mixins/UiManagerMixin";
import moment         from 'moment';
import {mapGetters} from "vuex";

export default {
    name      : "RentersListTable",
    mixins    : [UiManagerMixin],
    props     : ['noAction', 'title'],
    data      : () => ({
        dialog        : false,
        dialogDelete  : false,
        dialogPackages: false,
        skierTypePopup: false,
        editId        : null,
        editedItem    : new ReserveeModel(),
        defaultItem   : new ReserveeModel()
    }),

    computed: {
        headers() {
            const hdrs = [
                {text: '#', value: 'index', sortable: false, class: 'big-header'},
                {text: 'Renter', value: 'renter', sortable: false, class: 'big-header'},
                {text: 'Parameters', value: 'parameters', sortable: false, class: 'big-header'},
                {text: 'Skier Type', value: 'skier_type', sortable: false, class: 'big-header', align: 'center',},
                {text: 'Package', value: 'package_id', sortable: false, class: 'big-header', align: 'center',},

            ];
            if (!this.noAction) {
                hdrs.push({text: 'Actions', value: 'actions', sortable: false, class: 'big-header', align: 'center',});
            }
            return hdrs;
        },
        dateFormat() {
            return this.$store.state.config.dateFormat;
        },
        module_type_enabled(){
            return this.$store.state.resources.config.module_type_enabled;
        },
        module_type(){
            return this.$store.state.resources.config.module_type;
        },
        formTitle() {
            return this.editId === null ? 'New Renter' : ('Edit Renter #' + (this.$store.state.model.reservees.findIndex(r => r._id === this.editId) + 1))
        },
        reservees() {
            return this.$store.state.model.reservees;
        },
        skier_types() {
            return this.$store.state.resources.skier_types;
        },
        currentStep() {
            return this.$store.state.currentStepId;
        },
        reservation() {
            return this.$store.state.model.reservation;
        },
        multi_day_is_enabled() {
            return parseInt(this.$store.state.resources.config.multi_day_is_enabled);
        },
        multi_day_start_after() {
            return parseInt(this.$store.state.resources.config.multi_day_start_after);
        },
        frontend_view_folder() {
            return this.$store.state.resources.config.frontend_view_folder;
        },
        no_priceing_checkouts() {
            return this.$store.state.resources.config.no_priceing_checkouts;
        },
        is_holiday_or_weekend() {
            let day = this.$store.state.model.reservation.date_pickup;
            let is_holiday_or_week_day = false;
            if(this.$store.state.resources.config.holidays!==null){
                for (const [key, value] of Object.entries(this.$store.state.resources.config.holidays)) {
                    if(value.start!==null && value.end!==null) {
                        is_holiday_or_week_day = moment(day, 'YYYY-MM-DD').isBetween(moment(value.start, 'MM/DD/YYYY'), moment(value.end, 'MM/DD/YYYY'), null, '[]');
                        if (is_holiday_or_week_day) break;
                    }
                }
            }
            let is_weekend = moment(day).isoWeekday()==5 || moment(day).isoWeekday()==6;
            return is_weekend || is_holiday_or_week_day;
        },
        is_international_canadian(){
            return parseInt(this.$store.state.resources.config.is_international_canadian);
        },
        weight_unit_is_kg(){
            return parseInt(this.$store.state.resources.config.weight_unit_is_kg);
        },
        height_with_cm(){
            return parseInt(this.$store.state.resources.config.height_with_cm);
        },
        weight_with_kg(){
            return parseInt(this.$store.state.resources.config.weight_with_kg);
        },
        ...mapGetters(['is_in_special_period', 'special_period_increase', 'special_period_rate_type', 'do_not_show_price_on_checkout'])
    },

    watch: {
        dialog(val) {
            val || this.close()
        },
        dialogDelete(val) {
            val || this.closeDelete()
        },
        currentStep(newVal, oldVal) {
            if (oldVal == 1 && newVal == 2) {
                this.openNextEmpty();
            }
        }
    },


    methods: {
        openNextEmpty() {
            let emptyReservee = this.$store.state.model.reservees.find(r => !r.full_name);
            if (emptyReservee) {
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editItem(emptyReservee)
                });
            }
        },
        ageFromBday(date) {
            const bDay = moment(date);
            const age = moment().diff(bDay, 'years');
            return age;
        },
        formatDate(date) {
            return moment(date).format(this.dateFormat);
        },
        skierTypeById(id) {
            return this.$store.state.resources.skier_types.find(s => s.id == id);
        },
        indexOfItem(item) {
            return this.$store.state.model.reservees.indexOf(item) + 1;
        },
        packageById(id) {
            return this.$store.state.resources.packages.find(p => p.id === id);
        },
        packageText(item) {
            const pkg = this.packageById(item.package_id);
            const days = moment(this.$store.state.model.reservation.date_return).diff(moment(this.$store.state.model.reservation.date_pickup), 'days') + 1;
            let pkg_price = "";
            if(this.do_not_show_price_on_checkout!=1 && !(this.$store.state.model.reservation._type=='advance' && !this.$store.state.model.reservation.is_seasonal && this.no_priceing_checkouts==1)){
                if(this.$store.state.resources.config.frontend_view_folder == 'frontend.skigd'){
                    pkg_price = ((this.$store.state.model.reservation._type == 'kiosk' && this.$store.state.model.reservation.single_day_type=='afternoon')?pkg.half_day_rate: (this.$store.state.model.reservation.single_day_type=='night'?pkg.night_rate:pkg.current_rate ));
                }
                else if(this.$store.state.model.reservation.is_prepay){
                    pkg_price = (this.$store.state.resources.config.is_prepay_discount=="1" && this.$store.state.resources.config.prepay_discount!="0") ? pkg.current_rate + ' (-'+this.$store.state.resources.config.prepay_discount+'%)': pkg.current_rate;
                }
                else if(this.$store.state.resources.config.site_name == 'Mountain Ops VT' && this.module_type_enabled != 0 && this.module_type == 'module_2'){
                    pkg_price = (this.multi_day_is_enabled && days>this.multi_day_start_after && this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + this.getSpecialFullRate(pkg.current_rate, pkg.multi_day_rate, days):(this.multi_day_is_enabled && days>this.multi_day_start_after)?"$" + this.getPackagePrice(pkg.current_rate, pkg.multi_day_rate, days): this.$store.state.model.reservation.single_day_type=='day_hours' && this.is_holiday_or_weekend?pkg.weekends_and_holiday:this.$store.state.model.reservation.single_day_type=='day_hours' && !this.is_holiday_or_weekend?pkg.week_days_non_holiday:this.$store.state.model.reservation.single_day_type=='night_hours'?pkg.night_hours:(this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + this.getSpecialFullRate(pkg.current_rate, pkg.multi_day_rate, days):pkg.current_rate;
                }
                else if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_12'){
                    if(this.$store.state.model.reservation._type == 'advance'){
                        if(this.$store.state.model.reservation.single_day_type=='multiday'){
                            pkg_price = pkg.current_rate ;
                            // pkg_price = ((days == 2 )?pkg.day_2_Rate: (days == 3) ?pkg.day_3_Rate:(days == 4)?pkg.day_4_Rate:(days == 5)?pkg.day_5_Rate:(days > 5)?pkg.additional_day_rate:pkg.current_rate );
                        }else{
                            pkg_price = ((this.$store.state.model.reservation._type == 'advance' && this.$store.state.model.reservation.single_day_type=='afternoon')?pkg.halfDayRate: this.$store.state.model.reservation.single_day_type=='morning'?pkg.morningRate:this.$store.state.model.reservation.single_day_type=='twilight'?pkg.twilightRate:this.$store.state.model.reservation.single_day_type=='beech_pass'?pkg.beechPassRate:(this.$store.state.model.reservation.single_day_type=='night'?pkg.nightRate:pkg.current_rate )) ;
                        }
                    }else{
                        pkg_price = pkg.current_rate;
                    }
                }
                else if(this.$store.state.resources.config.delivery == 1 && window.location.href.includes('delivery')){
                    pkg_price = pkg.current_rate;
                }
                else if(this.module_type_enabled != 0 && this.module_type == 'module_7'){

                    pkg_price = ((this.multi_day_is_enabled && days>this.multi_day_start_after && this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + this.getSpecialRate(pkg.multi_day_rate):(days>this.multi_day_start_after && days<7 && !this.$store.state.model.reservation.is_seasonal)?pkg.multi_day_rate:(days>this.multi_day_start_after && days>=7 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_7_plus: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + this.getSpecialRate(pkg.multi_day_rate):pkg.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk) && !parseInt(this.$store.state.model.reservation.is_seasonal))?' (-'+this.discount+'%)':'');
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_5'){
                    if(window.location.hostname == 'rentals.alpenhausonline.com'){
                        pkg_price = ((days>5 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_6_rate:(days==5 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_5_rate:(days==4 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_4_rate:(days==3 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_3_rate:(days==2 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_2_rate: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + this.getSpecialRate(pkg.current_rate):pkg.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk) && !parseInt(this.$store.state.model.reservation.is_seasonal))?' (-'+this.discount+'%)':'');
                    }else{
                        pkg_price = (
                            (this.$store.state.resources.config.frontend_view_folder == "frontend.winterpark" && days > 8 && !this.$store.state.model.reservation.is_seasonal)
                                ? pkg.day_9_rate :
                            (this.$store.state.resources.config.frontend_view_folder == "frontend.winterpark" && days > 7 && !this.$store.state.model.reservation.is_seasonal)
                                ? pkg.day_8_rate :
                            (days > 6 && !this.$store.state.model.reservation.is_seasonal)
                                ? pkg.day_7_rate :
                            (days == 6 && !this.$store.state.model.reservation.is_seasonal)
                                ? pkg.day_6_rate :
                            (days == 5 && !this.$store.state.model.reservation.is_seasonal)
                                ? pkg.day_5_rate :
                            (days == 4 && !this.$store.state.model.reservation.is_seasonal)
                                ? pkg.day_4_rate :
                            (days == 3 && !this.$store.state.model.reservation.is_seasonal)
                                ? pkg.day_3_rate :
                            (days == 2 && !this.$store.state.model.reservation.is_seasonal)
                                ? pkg.day_2_rate :
                            (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)
                                ? "$" + this.getSpecialRate(pkg.current_rate)
                                : pkg.current_rate
                        ) +
                        (((this.discount_type == "percentage" && this.discount !== 0) &&
                           !parseInt(this.$store.state.model.reservation.is_from_kiosk))
                           ? ' (-' + this.discount + '%)' : '');
                    }
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_5_2'){
                    if(this.$store.state.model.reservation.single_day_type=='afternoon'){
                        pkg_price = pkg.half_day_rate;
                    }else{
                        pkg_price = ((days>6 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_7_rate:(days==6 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_6_rate:(days==5 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_5_rate:(days==4 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_4_rate:(days==3 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_3_rate:(days==2 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_2_rate: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + this.getSpecialRate(pkg.current_rate):pkg.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk) && !parseInt(this.$store.state.model.reservation.is_seasonal))?' (-'+this.discount+'%)':'');
                    }
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_5_3'){
                    if(this.$store.state.model.reservation.single_day_type=='afternoon'){
                        pkg_price = pkg.half_day_rate;
                    }else{
                        pkg_price = ((this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + this.getSpecialRate(pkg.current_rate):pkg.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk) && !parseInt(this.$store.state.model.reservation.is_seasonal))?' (-'+this.discount+'%)':'');
                    }
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_5_1'){
                    pkg_price = ((days>2 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_3_rate:(days==2 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_2_rate: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + this.getSpecialRate(pkg.current_rate):pkg.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk) && !parseInt(this.$store.state.model.reservation.is_seasonal))?' (-'+this.discount+'%)':'');
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_9') {
                    pkg_price = (this.$store.state.model.reservation.is_seasonal ? pkg.current_rate : (days > 1 && days < 4) ? pkg.day2_rate : (days >= 4) ? pkg.day_4_plus : this.$store.state.model.reservation.single_day_type == 'afternoon' ? pkg.half_day_rate : this.$store.state.model.reservation.single_day_type == 'night' ? pkg.night_rate : (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal) ? "$" + this.getSpecialRate(pkg.current_rate) : pkg.current_rate) + (((this.discount_type == "percentage" && this.discount !== 0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk) && !parseInt(this.$store.state.model.reservation.is_seasonal)) ? ' (-' + this.discount + '%)' : '');
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_10') {
                    pkg_price = (this.$store.state.model.reservation.is_seasonal ? pkg.current_rate : (days == 2) ? pkg.day2_rate : (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal) ? "$" + this.getSpecialRate(pkg.current_rate) : pkg.current_rate) + (((this.discount_type == "percentage" && this.discount !== 0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk) && !parseInt(this.$store.state.model.reservation.is_seasonal)) ? ' (-' + this.discount + '%)' : '');
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_11') {
                    pkg_price = (this.$store.state.model.reservation.is_seasonal ? pkg.current_rate : (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal) ? "$" + this.getSpecialRate(pkg.current_rate) : pkg.current_rate) + (((this.discount_type == "percentage" && this.discount !== 0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk)) ? ' (-' + this.discount + '%)' : '');
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_13') {
                    pkg_price = ((days>5 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_6_plus:(days>1  && !this.$store.state.model.reservation.is_seasonal)?pkg.day2_5: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + this.getSpecialRate(pkg.current_rate):pkg.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk) && !parseInt(this.$store.state.model.reservation.is_seasonal))?' (-'+this.discount+'%)':'');
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_14') {
                    pkg_price = ((days>3 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_4_plus:(days>1  && !this.$store.state.model.reservation.is_seasonal)?pkg.day2_rate: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + this.getSpecialRate(pkg.current_rate):pkg.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk) && !parseInt(this.$store.state.model.reservation.is_seasonal))?' (-'+this.discount+'%)':'');
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_16') {
                    pkg_price = ((days>4 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_5_rate:(days>2  && !this.$store.state.model.reservation.is_seasonal)?pkg.day3_4_rate:(days==2  && !this.$store.state.model.reservation.is_seasonal)?pkg.day2_rate: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + this.getSpecialRate(pkg.current_rate):pkg.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk) && !parseInt(this.$store.state.model.reservation.is_seasonal))?' (-'+this.discount+'%)':'');
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_17') {
                    pkg_price = ((this.$store.state.model.reservation._type == 'kiosk' && this.$store.state.model.reservation.single_day_type=='afternoon')?pkg.half_day_rate: (this.$store.state.model.reservation.single_day_type=='night'?pkg.night_rate:(this.multi_day_is_enabled && days>this.multi_day_start_after && !this.$store.state.model.reservation.is_seasonal)?pkg.multi_day_rate:pkg.current_rate ));    
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_18') {
                    pkg_price = ( this.$store.state.model.reservation.single_day_type=='night'?pkg.night_rate: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + this.getSpecialRate(pkg.current_rate):pkg.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk) && !parseInt(this.$store.state.model.reservation.is_seasonal))?' (-'+this.discount+'%)':'');
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_19') {
                    pkg_price = ((days>6 && !this.$store.state.model.reservation.is_seasonal)?pkg.week_rate:(days>3  && !this.$store.state.model.reservation.is_seasonal)?pkg.day_4_rate: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + this.getSpecialRate(pkg.current_rate):pkg.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk) && !parseInt(this.$store.state.model.reservation.is_seasonal))?' (-'+this.discount+'%)':'');
                }else{
                    pkg_price = (this.multi_day_is_enabled && days>this.multi_day_start_after && this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + this.getSpecialRate(pkg.multi_day_rate):(this.multi_day_is_enabled && days>this.multi_day_start_after)?pkg.multi_day_rate: this.$store.state.model.reservation.single_day_type=='day_hours' && this.is_holiday_or_weekend?pkg.weekends_and_holiday:this.$store.state.model.reservation.single_day_type=='day_hours' && !this.is_holiday_or_weekend?pkg.week_days_non_holiday:this.$store.state.model.reservation.single_day_type=='night_hours'?pkg.night_hours:(this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + this.getSpecialRate(pkg.current_rate):pkg.current_rate ;
                }
            }
            return pkg ? (pkg.title + ((!this.$store.state.model.reservation.group_link_id && this.do_not_show_price_on_checkout!=1 && !(this.$store.state.model.reservation._type=='advance' && !this.$store.state.model.reservation.is_seasonal && this.no_priceing_checkouts==1))?' (' + pkg_price + ')':"")) : 'Loading...';

        },
        addonsText(item) {
            return this.$store.state.resources.package_addons
                .filter(pa => item.addons.includes(pa.id))
                .map(pa => pa.title + ((!this.$store.state.model.reservation.group_link_id && this.do_not_show_price_on_checkout!=1 && !(this.$store.state.model.reservation._type=='advance' && !this.$store.state.model.reservation.is_seasonal && this.no_priceing_checkouts==1))?(' (' + ((this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?'$' + this.getSpecialRate(pa.price, 'addon'):pa.price )+ ')'):"")).join(', ');
        },
        editItem(item) {
            this.editId = item._id;
            const payload = {name: 'dialog_reservee_form'};
            if (item)
                payload.data = {
                    model: {
                        model: item,
                        next: this.openNextEmpty.bind(this)
                    }
                };
            this.ui__openModalByName(payload);
        },

        deleteItem(item) {
            this.editId = item._id;
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },

        deleteItemConfirm() {
            this.$store.commit('reservee_delete', this.editId)
            this.closeDelete()
        },

        getHeightText(item) {
            return item.name +' ( '+ item.cm_value + ' cm )';
        },
        heightCm(height){
            let text = height;
            if(this.height_with_cm || this.$store.state.model.reservation.is_international_customer  || parseInt(this.$store.state.resources.config.is_international_canadian)){
                const myHeight = height.split("'");
                const totalInches = parseInt(myHeight[0]) * 12 + parseInt(myHeight[1]);
                const cm = Math.round(totalInches * 2.54);
                if(this.height_with_cm || this.$store.state.model.reservation.is_international_customer  || parseInt(this.$store.state.resources.config.is_international_canadian)){
                    text += ' ( '+ cm + ' cm )';
                }
            }
            return text;
        },
        shoeSize(size){
            let shoe_size = size;
            if(size.includes("C") && (this.$store.state.model.reservation.is_international_customer  || parseInt(this.$store.state.resources.config.is_international_canadian))){
                shoe_size += ' ( ' +(parseFloat(size) - 1) + 'C UK)';
            }else if( size >= 3 ){
                if (this.$store.state.model.reservation.is_international_customer || parseInt(this.$store.state.resources.config.is_international_canadian)) {
                    shoe_size += ' ( ' + (size - 1) + ' UK)';
                }
            }
            return shoe_size;
        },
        closeDelete() {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editId = null
            })
        },
        getSpecialRate(baseRate, type = null) {
            const rate = parseFloat(baseRate.replace('$',''));
            
            if (this.special_period_rate_type === 'percent') {
                return (rate + (rate * this.special_period_increase) / 100).toFixed(2);
            }

            if (this.special_period_rate_type === 'fixed' && type != 'addon') {
                return (rate + this.special_period_increase).toFixed(2);
            }

            return rate.toFixed(2);
        },
        getSpecialFullRate(currentRate, multiDayRate, days) {
            let current_rate = parseFloat(currentRate.replace('$',''));
            let multi_day_rate = 0;
            if(days > 1){
                multi_day_rate = parseFloat(multiDayRate.replace('$',''));
            }
            let rate = current_rate;
            if(multi_day_rate && days > 1){
                rate = current_rate + (multi_day_rate * (days - 1));
            }
            
            if (this.special_period_rate_type === 'percent') {
                return (rate + (rate * this.special_period_increase) / 100).toFixed(2);
            }

            if (this.special_period_rate_type === 'fixed') {
                return (rate + this.special_period_increase).toFixed(2);
            }

            return rate.toFixed(2);
        },
        getPackagePrice(currentRate, multiDayRate, days) {
            let current_rate = parseFloat(currentRate.replace('$',''));
            let multi_day_rate = parseFloat(multiDayRate.replace('$',''));
            let rate = current_rate;
            if(multi_day_rate && days > 1){
                rate = current_rate + (multi_day_rate * (days - 1));
            }
            return rate.toFixed(2);
        }
    }
};
</script>

<style lang="scss">
.renters-list-table.v-data-table {
    .big-header {
        font-size: 1.1rem !important;
    }

    table th + th {
        border-left: 1px solid #dddddd;
    }

    table td + td {
        border-left: 1px solid #dddddd;
    }

    td {
        vertical-align: middle !important;
    }

    .v-toolbar__content, .v-toolbar__extension {
        padding-left: 0;
    }
    .text-light-blue{
        color: #1976d2;
        cursor: pointer;
    }
}
</style>
